<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div
            class="control__trigger"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
          >
            <img
              src="https://sirv.sirv.com/website/theme2/icon/question.svg"
              :alt="hint"
            >
          </div>
          <div
            v-show="showHint"
            class="hint"
          >
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{disabled: !selectStatus}"
          @click="selectStatus =! selectStatus"
        />
        <div
          class="imageoptions"
        >
          <div
            v-for="(item, i) in src"
            :key="i"
            class="imageoptions__item"
            :class="{'active': i === active && selectStatus === true}"
            @click="changeImage(i)"
          >
            <img :src="item.url">
          </div>
        </div>
      </div>
      <el-checkbox
        v-model="selectStatus"
        class="control__checkbox"
        @change="changeOptionCSS"
      />
    </div>
  </div>
</template>
<script>
import src from '@/assets/image_fullscreeniconopen.json'
import { mapState } from 'vuex'
export default {
  name: 'ImageIconOpenCSS',
  props: {
    title: {
      type: String,
      default: ''
    },
    default: {
      type: Number,
      default: 0
    },
    hint: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean
    },
    parameter: {
      type: String,
      default: ''
    },
    eventClick: {
      type: Boolean
    }
  },
  data () {
    return {
      src: src,
      value: src[this.default],
      active: this.default,
      selectStatus: this.status,
      showHint: false
    }
  },
  computed: {
    ...mapState(['clearOptionsCSS'])
  },
  watch: {
    clearOptionsCSS (val) {
      if (val) {
        this.selectStatus = false
      }
    },
    eventClick (val) {
      this.selectStatus = val
      this.value = this.default
      this.active = this.default
    },
    selectStatus (val) {
      if (val === true) {
        this.changeImage(this.active)
        this.changeOptionCSS()
      }
    }
  },
  methods: {
    changeImage (i) {
      let url = this.src[i].url || ''
      this.active = i
      this.value = url
      this.changeOptionCSS()
    },
    changeOptionCSS () {
      const value = this.selectStatus === true ? `${this.value}` : ''
      this.$emit('changeOptionCSS', {
        type: this.type,
        parameter: `${this.parameter}`,
        separator: ':',
        value: `${value}`
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.imageoptions {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  &__item{
    max-width: 50px;
    width: 100%;
    height: 50px;
    justify-content: center;
    margin: 0 2.5px 5px;
    cursor: pointer;
    padding: 5px;
    border: 1px solid transparent;
    &.active {
      border-radius: 4px;
      border-color: rgba(50, 123, 186, 0.9);
    }
  }
}
</style>
